import React, { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { getCurrencyData } from './currency&PriceUtil.js';
import { Tooltip } from 'react-tooltip';
import InfoIcon from '@mui/icons-material/Info';
import './css/OpportunityCreationPage.css';
import JWTErrorPopup from './JWTErrorPopup'; // Import the popup component
import { handleJWTResponse } from './jwtErrorHandler'; 
// const { APP_ID, APP_ICON, APP_MODULE_URL } = window.APP_CONFIG;
function OpportunityCreationPage4() {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false); // Add loading state
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);

    const { firmName, selectedCurrency, firmId, accountId, email } = location.state;
    const [showJWTError, setShowJWTError] = useState(false);
                const [jwtErrorMessage, setJwtErrorMessage] = useState('');
            
                const closeJWTErrorPopup = () => {
                    setShowJWTError(false);
                    navigate('/firm');
                };
        
    const [users, setUsers] = useState([
        {
            username: '',
      isVerified: false,
      usernameToCopy: '',
      isVerifiedToCopy: false,
      cdtSettings: '',
      speedDials: '',
      notes: '',
      isCollapsed: false,
      errors: []
        },
    ]);

    const { symbol: currencySymbol, pricing } = getCurrencyData(selectedCurrency, 'User Copy Layout Only Request' );
    const { baseCostPerUser, services, productTypes } = pricing;

    // Handle input changes for user fields
    const handleUserChange = (index, field) => (event) => {
        const updatedUsers = [...users];
        updatedUsers[index][field] = event.target.value;

        const errors = updatedUsers[index].errors.filter((error) => error !== field);
        updatedUsers[index].errors = errors;

        // If username is changed, reset verification status
       if (field === "username") {
            updatedUsers[index].isVerified = false;
        } else if (field === "usernameToCopy") {
            updatedUsers[index].isVerifiedToCopy = false;
        }

        setUsers(updatedUsers);
    };


    // Add a new user
    const handleAddUser = () => {
        if (users.length < 5) {
        setUsers([
            ...users,
            {
                username: '',
                isVerified: false,
                usernameToCopy: '',
                isVerifiedToCopy: false,
                cdtSettings: '',
                speedDials: '',
                notes: '',
                isCollapsed: false,
                errors: []
            },
        ]);
        }else{
            alert('You can only add up to 5 users. If you need to add more than 5 users, please contact sales@symphony.com');
    }
    };

    // Remove a user by index
    const handleRemoveUser = (index) => {
        setUsers(users.filter((_, i) => i !== index));
    };

    // Handle collapsing a user's form
    const handleCollapseUser = (index) => () => {
        const updatedUsers = [...users];
        updatedUsers[index].isCollapsed = true;
        setUsers(updatedUsers);
    };

    // Handle expanding a user's form
    const handleExpandUser = (index) => () => {
        const updatedUsers = [...users];
        updatedUsers[index].isCollapsed = false;
        setUsers(updatedUsers);
    };

    // Calculate total cost for a single user
    const calculateTotalForUser = (user) => {
      
        return baseCostPerUser;
    };

    // Calculate total cost for all users
    const calculateTotalCost = () => {
        return users.reduce((total, user) => total + calculateTotalForUser(user), 0);
    };

    // const totalProvisionCost = users.length * baseCostPerUser;
    const totalProvisionCost = 0;
   
    const totalCost = totalProvisionCost;

    const handleVerifyUsername = (index) => {
        const username = users[index].username;

        fetch(`https://cloud9requests.symphony.com/requests/api/verify_username`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ username }),
        })
            .then(response => handleJWTResponse(response, setJwtErrorMessage, setShowJWTError))
            .then((data) => {
                const updatedUsers = [...users];
                updatedUsers[index].isVerified = !data.isAvailable;
                setUsers(updatedUsers);
            })
            .catch(error => {
                if (error.message !== "JWT error handled") {
                    console.error('Error verifying email:', error);
                }
            });
    };

    const handleVerifyUsernameToCopy = (index) => {
        const usernameToCopy = users[index].usernameToCopy;

        fetch(`https://cloud9requests.symphony.com/requests/api/verify_username`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ username: usernameToCopy }),
        })
            .then(response => handleJWTResponse(response, setJwtErrorMessage, setShowJWTError))
            .then((data) => {
                const updatedUsers = [...users];
                updatedUsers[index].isVerifiedToCopy = !data.isAvailable;
                setUsers(updatedUsers);
            })
            .catch(error => {
                if (error.message !== "JWT error handled") {
                    console.error('Error verifying email:', error);
                }
            });
    };

    const fieldLabels = {
        username: "Username not verified, must be unique",
        usernameToCopy : "Username to be copied is not verified or Empty",
        productType: "Product Type",
        recording: "Recording",
        officeAddress: "Office Address",
        ssoUsername: "SSO Username",
        notes: "Notes",
    };
    const handleOkClick = (index) => {
        const user = users[index];
        const requiredFields = ["username","usernameToCopy"];
        const errors = requiredFields.filter((field) => !user[field]);
        console.log(errors);

        if (!user.isVerified) {
            errors.push("username");
        }

        if (!user.isVerifiedToCopy) {
            errors.push("usernameToCopy");
        }

        const updatedUsers = [...users];
        updatedUsers[index].errors = errors;
        setUsers(updatedUsers);

        if (errors.length === 0) {
            // Collapse the form if no errors
            handleCollapseUser(index)();
        }
    };

    // Handle form submission
    const handleSubmit = () => {
        const anyOpenOrError = users.some((u) => !u.isCollapsed || u.errors.length > 0);

        if (anyOpenOrError) {
          alert("Please click OK on all users before submitting.");
          return;
        }

        setIsConfirmOpen(true);
       
    };

    const handleConfirmYes = () => {
        setIsConfirmOpen(false);
        setLoading(true);
        const usersWithCost = users.map(user => ({
            ...user,
            //totalPerUser: calculateTotalForUser(user),
            totalPerUser: 0,
          }));
    

        fetch('https://cloud9requests.symphony.com/requests/api/create_opportunity', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({
                firmId: firmId,
                accountId: accountId,
                // billingEntity: selectedEntity.Id,
                billingEntityCurrency: selectedCurrency,
                firmName : firmName,
                requestType : 'User Copy Layout Only Request',
                users: usersWithCost,
                email : email, 
                totalCost: 0,
            }),
        })
        .then(response => handleJWTResponse(response, setJwtErrorMessage, setShowJWTError))
        .then((data) => {
            console.log('User request created:', data);
            setLoading(false);
            navigate('/summary', { state: { data } });
        })
        .catch(error => {
            if (error.message !== "JWT error handled") {
                console.error('Error creating opportuntiy:', error);
            }
        });

    }

    return (
                    <div className="opportunity-page">
                        {/* <Link to="/billingEntity" className="back-link">
                            Back
                        </Link> */}
                                                    {/* JWT Error Popup */}
                                                {showJWTError && (
                                                    <JWTErrorPopup 
                                                        message={jwtErrorMessage} 
                                                        onClose={closeJWTErrorPopup} 
                                                       />
                                                        )}
                       <button
                    onClick={() => {
                                navigate('/optionsPage', {
                                    state: { 
                                        firmName,
                                        selectedCurrency,
                                        firmId,
                                        accountId,
                                        email
                                    }
                                });
                            }}
                            className="back-link"
                        >
                            Back
                        </button>
                        <div className="opportunity-container">
                            <img
                                src = "https://cloud9requests.symphony.com/Cloud9_Logo.png"
                                alt="C9 Logo"
                                className="logo"
                            />
                            <h2 className="form-title">Submit User Request</h2>
                            <h3 className="firm-details">
                                Firm Name: {firmName} | Currency: {selectedCurrency} <br /><br />
                                User Layout Copy - Includes replication of Groups, Shoutdowns, Ringdowns and User Layout. Cloud Dial Tone copy on demand.
                            </h3>

                <div className="form-section">
                    {users.map((user, index) => (
                        <div key={index}>
                            {user.isCollapsed ? (
                                // Render collapsed view
                                <div className="collapsed-user">
                                    <p>
                                    <strong>User {index + 1}:</strong><strong>Cost :  {currencySymbol}0</strong>
                                    </p>
                                    <button onClick={handleExpandUser(index)} className="edit-button">
                                        Edit
                                    </button>
                                </div>
                            ) : (
                                // Render full form
                                <div className="user-row">
                                    <div className="user-details">
                                        <h3>User Information</h3>
                                    <label>
                                    Username of User to Copy To <span style={{ color: "red" }}>&#42;</span>:
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <input
                                            type="text"
                                            value={user.username}
                                            onChange={handleUserChange(index, "username")}
                                            required
                                        />
                                        <button
                                            onClick={() => handleVerifyUsername(index)}
                                            className="add-user-button"
                                            style={{ marginLeft: "10px" }}
                                        >
                                            Verify
                                        </button>
                                    </div>
                                    {user.isVerified ? (
                                        <p style={{ color: "green", marginTop: "5px" }}>Username to copy to is validated</p>
                                    ) : (
                                        <p style={{ color: "red", marginTop: "5px" }}>
                                            {user.username ? "Username to copy to is not verified" : ""}
                                        </p>
                                    )}
                                </label>
                                <label>
                                            Username of User to Copy From<span style={{ color: "red" }}>&#42;</span>:
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                <input
                                                    type="text"
                                                    value={user.usernameToCopy}
                                                    onChange={handleUserChange(index, "usernameToCopy")}
                                                    required
                                                />
                                                <button
                                                    onClick={() => handleVerifyUsernameToCopy(index)}
                                                    className="add-user-button"
                                                    style={{ marginLeft: "10px" }}
                                                >
                                                    Verify
                                                </button>
                                            </div>
                                            {user.isVerifiedToCopy ? (
                                                <p style={{ color: "green", marginTop: "5px" }}>
                                                    Username to copy from is validated.
                                                </p>
                                            ) : (
                                                <p style={{ color: "red", marginTop: "5px" }}>
                                                    {user.usernameToCopy ? "Username to copy from not verified" : ""}
                                                </p>
                                            )}
                                        </label>
                                
                                 
                                       
                                        <label>
                                            Copy CDT Settings<span style={{ color: 'red'}}>&#42;</span>:
                                            <select
                                                value={user.cdtSettings}
                                                onChange={handleUserChange(index, 'cdtSettings')} required
                                            >
                                                <option value="">Select</option>
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                            </select>
                                           
                                        </label>
                                        {user.cdtSettings === 'Yes' && (
                                            <>
                                                <label>
                                                    Copy Speed Dials:
                                                    <select
                                                        value={user.speedDials}
                                                        onChange={handleUserChange(index, 'speedDials')}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="Yes">Yes</option>
                                                        <option value="No">No</option>
                                                    </select>
                                                </label>
                                               
    
                                            </>
                                        )}
                                       
                                       
                                      
                                        <label>
                                          Notes<span style={{ color: 'red'}}>&#42;</span>:
                                            <input
                                                type="text"
                                                value={user.notes}
                                                onChange={handleUserChange(index, 'notes')}
                                                required
                                            />
                                        </label>
                                        {user.errors.length > 0 && (
                                            <div style={{ color: "red", marginTop: "10px" }}>
                                                <p>Please fill in the following fields:</p>
                                                <ul>
                                                {user.errors.map((error, i) => (
                                                    <li key={i}>{fieldLabels[error]}</li>
                                                ))}
                                            </ul>
                                            </div>
                                        )}
                                        <button
                                    onClick={() => handleOkClick(index)}
                                    className="add-user-button"
                                    // disabled={isOkButtonDisabled(user)}
                                >
                                    OK
                                </button>
                                        {index > 0 && (
                                            <button
                                                onClick={() => handleRemoveUser(index)}
                                                className="remove-user-button"
                                            >
                                                Remove User
                                            </button>
                                        )}
                                    </div>

                                    <div className="rate-card">
                                        <h3>Rate Card</h3>
                                        <div className="rate-details">
                                        <p>
                                                <strong>One Time Cost:</strong><br/>
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>Provisioning Cost:</strong> {currencySymbol}0
                                            </p>
                                            {/* <h5>Additional Services</h5>
                                            {services.map((service) => (
                                                <label key={service.id} className="service-option">
                                                    <input
                                                        type="checkbox"
                                                        checked={user.selectedServices.includes(service.id)}
                                                        onChange={() => handleServiceToggle(index, service.id)}
                                                    />
                                                    {service.name} - {currencySymbol}{service.cost}
                                                </label>
                                            ))} */}
                                            <p>
                                                <strong>Total for User:</strong> {currencySymbol}0
                                                {/* {calculateTotalForUser(user)} */}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                    
                    <button onClick={handleAddUser} className="add-user-button">
                        Add Additional Users
                    </button>
                </div>
                <div className="total-cost">
                    <h3>Cost Summary</h3>
                    <p>Provisioning Cost (All Users): {currencySymbol}{totalProvisionCost}</p>
                    {/* <p>Product Cost (All Users): {currencySymbol}{totalProductCost}</p> */}
                    {/* <p>Services Cost (All Users): {currencySymbol}{totalServicesCost}</p> */}
                    <p>
                        <strong>Total Cost:</strong> {currencySymbol}{totalCost}
                    </p>
                </div>
                {loading ? (
                    <div className="loading-container">
                        <p>Processing... Please wait</p>
                        <div className="spinner"></div> {/* Add spinner */}
                    </div>
                    ) : (
                    <button onClick={handleSubmit} className="submit-button">
                        Submit
                    </button>
                    )}
                {isConfirmOpen && (
                        <div className="modal-overlay">
                          <div className="modal-content">
                            <h3>Confirm Submission</h3>
                            <p>By submitting this form you are agreeing to the associated costs</p>
                            <p>Are you sure you want to submit?</p>
                           
                            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                              <button onClick={handleConfirmYes}>Yes</button>
                              <button onClick={() => setIsConfirmOpen(false)}>No</button>
                            </div>
                          </div>
                        </div>
                      )}
            </div>
        </div>
    );
}

export default OpportunityCreationPage4;

